import React, { createContext, useContext } from "react";
import type { UseFormReturn } from "react-hook-form";
import noop from "lodash/noop";
import type {
  MonitorSearchValues,
  MonitorSearchFilterForm,
} from "../monitor.type";
import { defaultMonitorSearchValues } from "../monitor.constants";

interface MonitorSearchContextValue {
  searchData: MonitorSearchValues;
  setSearchData: (_data: MonitorSearchValues) => void;
  hasSearched: boolean;
  setHasSearched: (_searched: boolean) => void;
  monitorSearchForm: UseFormReturn<MonitorSearchValues> | null;
  setMonitorSearchForm: (
    _form: UseFormReturn<MonitorSearchValues> | null
  ) => void;
  monitorSearchFilterForm: UseFormReturn<MonitorSearchFilterForm> | null;
  setMonitorSearchFilterForm: (
    _form: UseFormReturn<MonitorSearchFilterForm> | null
  ) => void;
  currentPageNumber: number;
  setCurrentPageNumber: (_page: number) => void;
}

interface ProviderProps {
  value: MonitorSearchContextValue;
  children: React.ReactNode;
}

const MonitorSearchContext = createContext<MonitorSearchContextValue>({
  searchData: defaultMonitorSearchValues,
  setSearchData: noop as (_data: MonitorSearchValues) => void,
  hasSearched: false,
  setHasSearched: noop as (_searched: boolean) => void,
  monitorSearchForm: null,
  setMonitorSearchForm: noop as (
    _form: UseFormReturn<MonitorSearchValues> | null
  ) => void,
  monitorSearchFilterForm: null,
  setMonitorSearchFilterForm: noop as (
    _form: UseFormReturn<MonitorSearchFilterForm> | null
  ) => void,
  currentPageNumber: 1,
  setCurrentPageNumber: noop as (_page: number) => void,
});

export const useMonitorSearchContext = (): MonitorSearchContextValue =>
  useContext(MonitorSearchContext);

export const MonitorSearchProvider: React.FC<ProviderProps> = ({
  value,
  children,
}) => {
  return (
    <MonitorSearchContext.Provider value={value}>
      {children}
    </MonitorSearchContext.Provider>
  );
};

export default MonitorSearchContext;
